import React, { Component } from "react";
import { FiX , FiMenu } from "react-icons/fi";


class HeaderFive extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded')
        })
    }
    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }
    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }
    render(){
        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }

        const { color , headerPosition } = this.props;
        // const { logo, color , headerPosition } = this.props;
        // let logoUrl;
        // if(logo === 'light'){
        //     logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Trydo" />;
        // }else if(logo === 'dark'){
        //     logoUrl = <img src="/assets/images/logo/logo-dark.png" alt="Trydo" />;
        // }else if(logo === 'symbol-dark'){
        //     logoUrl = <img src="/assets/images/logo/logo-symbol-dark.png" alt="Trydo" />;
        // }else if(logo === 'all-dark'){
        //     logoUrl = <img src="/assets/images/logo/logo-all-dark.png" alt="Trydo" />;
        // } else if(logo === 'symbol-light'){
        //     logoUrl = <img src="/assets/images/logo/logo-symbol-light.png" alt="Trydo" />;
        // }else{
        //     logoUrl = <img src="/assets/images/logo/logo.png" alt="Trydo" />;
        // }

        return(
            <header className={`header-area formobile-menu ${headerPosition} ${color}`}>
                <div className="header-wrapper" id="header-wrapper">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-3 col-md-4 col-6">
                                <div className="header-left">
                                    <div className="logo">
                                        <a href="/">
                                            {/* {logoUrl} */}
                                            <span
                                                style={{
                                                    fontSize: "30px",
                                                    fontWeight: "bold",
                                                }}
                                            >ALICE DENENBERG</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-9 col-md-8 col-6">
                                <div className="header-right justify-content-end">
                                    <nav className="mainmenunav primary-header-nav d-lg-block">
                                        <ul className="mainmenu">
                                            <li>
                                                <a href="/#services">Services</a>
                                            </li>
                                            <li>
                                                <a href="/#about">About</a>
                                            </li>
                                            <li>
                                                <a href="/#articles">Articles/Presentations</a>
                                            </li>
                                            <li>
                                                <a href="/brand-protection-insights">Brand Protection Insights</a>
                                            </li>
                                        </ul>
                                    </nav>
                                    <div className="header-btn">
                                        <a
                                            className="rn-btn"
                                            href="https://www.linkedin.com/in/alicedenenberg/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <span>connect</span>
                                        </a>
                                    </div>
                                    {/* Start Humberger Menu  */}
                                    <div className="humberger-menu d-block d-lg-none pl--20">
                                        <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                                    </div>
                                    {/* End Humberger Menu  */}
                                    <div className="close-menu d-block d-lg-none">
                                        <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default HeaderFive;
